import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";

interface Props {
  label: React.ReactNode;
  // Used only to build a stable data-test-id/key-safe slug - kept separate from `label` since
  // label can be arbitrary JSX (e.g. Engagement's own colored category dot next to the name), not
  // just a plain string to slugify directly.
  testKey: string;
  count: number;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

// Same collapsible chevron+header+count interaction as CollapsibleDashboardGroup on the Dashboards
// page (src/pages/Dashboards/components/CollapsibleDashboardGroup.tsx) - a fresh, presentational,
// children-based sibling rather than reusing that component directly, since it hardcodes rendering
// DashboardCard children internally, unlike Settings' own Engagement cards / access-request rows.
export const CollapsibleCategorySection = (props: Props) => {
  const { label, testKey, count, isOpen, onToggle, children } = props;
  const slug = testKey.toLowerCase().replace(/\s+/g, "-");

  return (
    <div className="settings_collapsible_group" data-test-id={`settings-collapsible-group-${slug}`}>
      <div className="settings_collapsible_group_header_row">
        <button
          className="settings_collapsible_group_chevron"
          onClick={onToggle}
          aria-expanded={isOpen}
          aria-label={isOpen ? "Collapse" : "Expand"}
        >
          {isOpen ? <ExpandMoreIcon /> : <ChevronRightIcon />}
        </button>

        <button className="settings_collapsible_group_header" onClick={onToggle} aria-expanded={isOpen}>
          {label} <span className="settings_collapsible_group_count">({count})</span>
        </button>
      </div>

      {isOpen && children}
    </div>
  );
};
